import React from 'react'
import { FormikProps, useFormikContext } from 'formik'
import {
  BoxV4,
  RadioButtonGroupMapping,
  RadioButtonType,
  RadioButtonsV2,
} from '@labrav/react-components'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRepeat } from '@fortawesome/pro-regular-svg-icons'
import { MsftCombinedFormState } from '../../../../modules/microsoftCombinedForm/reducer'
import { useStyles } from '../../../PrivateOfferFormV2/AzureOffer/Renewal/Renewal.styles'
import {
  CombinedFormFAQs,
  CombinedFormFAQsItem,
} from '../CombinedFormFAQs/CombinedFormFAQs'

export const renewalOptions: RadioButtonGroupMapping[] = [
  {
    key: 'Yes',
    label: 'Yes',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'No',
    label: 'No',
    type: RadioButtonType.STANDARD,
  },
]

export const Renewal = () => {
  const { values, setFieldValue } =
    useFormikContext() as FormikProps<MsftCombinedFormState>
  const { classes } = useStyles()

  const handleSelection = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value
    if (value === 'Yes') {
      await setFieldValue('draftOffer.existingContractRenewal', true)
    } else if (value === 'No') {
      await setFieldValue('draftOffer.existingContractRenewal', false)
    } else {
      await setFieldValue('draftOffer.existingContractRenewal', false)
    }
  }
  const checkedValue = () =>
    values?.draftOffer?.existingContractRenewal
      ? 'Yes'
      : values?.draftOffer?.existingContractRenewal === false
        ? 'No'
        : ''
  return (
    <div data-testid="renewal-section">
      <BoxV4
        heading={'Renewal'}
        headingIcon={
          <FontAwesomeIcon
            icon={faRepeat}
            style={{ width: '16px', height: '16px' }}
          />
        }
        secondaryActions={
          <CombinedFormFAQs item={CombinedFormFAQsItem.RENEWAL} />
        }
      >
        <div className={classes.sectionContainer}>
          <>
            <Typography className={classes.sectionText}>
              Is this offer intended to renew a current offer or an existing
              paid contract in effect within or outside of Commercial
              Marketplace?
            </Typography>
            <div className={classes.widthRadio}>
              <RadioButtonsV2
                checkedValue={{
                  key: checkedValue(),
                  value: checkedValue(),
                }}
                name={'draftOffer.existingContractRenewal'}
                handleChange={handleSelection}
                radioButtonMappings={renewalOptions.map(option => ({
                  ...option,
                }))}
              />
            </div>
          </>
        </div>
      </BoxV4>
    </div>
  )
}
